/********************************************************************************
 * メインモジュール
 *
 * @since 2023/02/20
 * @author 松本裕介
 *
 *********************************************************************************/

//#region モジュールのインポート

import { createApp, provide, h } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { key, store }from './store'

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"

import { DefaultApolloClient } from '@vue/apollo-composable';
import {ApolloClient, createHttpLink, InMemoryCache,} from '@apollo/client/core';

//#endregion

//#region Apolloクライアント設定

console.log(process.env.VUE_APP_GRAPHQL_API);

// ApolloサーバのURIを作成
const httpLink = createHttpLink({
  uri: process.env.VUE_APP_GRAPHQL_API,
});

// キャッシュ方法を設定
const cache = new InMemoryCache();

// Apolloクライアントのインスタンスを作成
const apolloClient = new ApolloClient({
  link: httpLink,
  cache,
});

//#endregion

//#region アプリ設定

const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient);
  },
  render: () => h(App),
});

// アプリのエントリポイントをマウント
app.use(store, key).use(router).mount('#app');

//#endregion
